// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import ComparisonView from "../../components/rgsICU/comparison";

const Comparison = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <ComparisonView />
    </Main>
  </>
);

export default Comparison;
